import { getAppUrl } from "@/lib/app-url";

/** Публичный origin сайта для canonical / OG / sitemap. */
export function getSiteUrl(): string {
  return getAppUrl();
}

/** Публичный URL страницы. Главная — без завершающего слэша (как canonical в Next.js). */
export function absoluteUrl(path = "/"): string {
  const base = getSiteUrl();
  if (!path || path === "/") return base;
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
